<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para1"><a id="page_2"></a>Tor Books by Margaret Weis and Tracy Hickman</p>
<p class="para"> </p>
<p class="center-para1"><em>Bones of the Dragon<br/>Secret of the Dragon</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?666c2fd6